export function blockTestRender() {
  return process.env.NODE_ENV !== 'test';
}
